const PAY_BASE = "https://customer-assets-4nw71qhi.emergentagent.net/job_smarti-renew-store/artifacts";

// Accepted payment methods (real logos supplied by the client).
export const PAYMENT_LOGOS = [
  { name: "Bancontact", logo: `${PAY_BASE}/8nu31pym_Bancontact-card.png` },
  { name: "Apple Pay", logo: `${PAY_BASE}/qmx0vs7p_Apple-pay-card.png` },
  { name: "Google Pay", logo: `${PAY_BASE}/u3291civ_Google-Pay-card.png` },
  { name: "Carte bancaire", logo: `${PAY_BASE}/jhi3egqj_Credit-card-card.png` },
  { name: "Alma", logo: `${PAY_BASE}/5xi87uql_Alma-card-card.png` },
];
